import { postLogin } from "../../../apiCalls/caller";
import { removeUserData, setUserData } from "../../../utils/StorageManager";

import {
  loginSuccess,
  logoutUserSuccess,
  apiError,
  reset_login_flag,
} from "./reducer";

export const loginUser = (user, history) => async (dispatch) => {
  try {
    const { rememberMe, ...credentials } = user;
    let response = await postLogin(credentials);
    if (response.success) {
      if (response.message !== "Redirect") {
        setUserData(response.data, rememberMe);
        const redirectURL = localStorage.getItem("postLoginRedirect");
        if (redirectURL) {
          history(redirectURL);
          localStorage.removeItem("postLoginRedirect");
        } else if (response.data?.user_freeType === "trial") {
          history("/trial-welcome");
        } else {
          history("/products");
        }
      } else {
        window.location.href = response.data;
      }
    } else {
      dispatch(apiError(response));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    removeUserData();

    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    const socialdata = await response;
    if (socialdata) {
      setUserData(response);
      dispatch(loginSuccess(response));
      history("/dashboard");
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
